module.exports = __webpack_public_path__ + "static/media/home-product-3.3cc9c945.png";